<div class="container">
    <div class="error-image"></div>
    <div class="error-title">
        {{ 'pageNotFound.title' | translate }}
    </div>
    <div class="error-text">
        {{ 'pageNotFound.message' | translate }}
    </div>
</div>
